import styled from 'styled-components';
export const Image = styled.img`
  height: 40px;
`;